<template>
    <div class="card-body nch--forum-card mb-3">
        <div class="flex-column">
            <div v-if="selectedTopicInfo">
                <h1 class="mb-0">{{selectedTopicInfo.title}}</h1>
                <hr class="mt-2 mb-4" />
            </div>
            <ForumAnswer v-for="(answer, index) in answers" :key="index" :answer="answer" />
        </div>
        <template v-if="!user.public">
            <Editor
                class="nch--html-editor"
                v-model="model"
                v-validate="'required'"
                :name="$t('topic.question')"
            />
            <div class="d-flex flex-row-reverse">
                <BaseButton
                    class="mt-3"
                    :style="$bgColor(color.primary)"
                    :disabled="disableBtn"
                    @click="postAnswer(id)"
                >{{$t('topic.post')}}</BaseButton>
            </div>
        </template>
        <template v-else>
            <span>{{ $t('topic.needs_login') }}</span>
        </template>
    </div>
</template>

<script>
import Editor from "../../argon/components/Inputs/HtmlEditor";
import BaseButton from "../../argon/components/BaseButton";

import ForumAnswer from "./ForumAnswer";
export default {
    name: "ForumAnswers",
    components: {
        Editor,
        BaseButton,
        ForumAnswer
    },
    props: {
        selectedTopicInfo: {
            type: Object | null,
            required: true
        },
        color: {
            type: Object,
            required: true
        },
        moderated: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            answers: [],
            meta: {},
            links: {},
            postedAt: [],
            model: "",
            id: ""
        };
    },
    watch: {
        selectedTopicInfo(newValue, oldValue) {
            if (newValue.id !== oldValue.id) {
                this.answers = [];
                this.id = newValue.id;
            }
            this.getAnswers(newValue.id);
        }
    },
    computed: {
        disableBtn() {
            if (!this.model) return true;
        },
        user() {
            return this.$store.getters.USER;
        }
    },
    methods: {
        postAnswer(id) {
            this.$loading.show();
            return window.axios
                .post(`/api/app/topics/${id}/answers`, {
                    comment: this.model
                })
                .then(res => {
                    if (this.moderated) {
                        this.$notify({
                            type: "warning",
                            message: $t("topic.new_moderated")
                        });
                    }
                    this.$notify({
                        type: "success",
                        message: res.data.message
                    });
                })
                .catch(err => {
                    console.error(err);
                    this.$notify({
                        type: "danger",
                        message: err.response.data.error
                    });
                })
                .finally(() => {
                    this.$loading.close();
                    this.getAnswers(id);
                    this.model = "";
                });
        },
        getAnswers(id, page) {
            this.$loading.show();
            return window.axios
                .get(`/api/app/topics/${id}/answers`, {
                    params: {
                        page: page ? page : 1,
                        per_page: 999
                    }
                })
                .then(res => {
                    this.answers = res.data.data;
                    this.meta = res.data.meta;
                    this.links = res.data.links;
                })
                .catch(err => console.error(err))
                .finally(() => this.$loading.close());
        }
        // scroll() {
        //     window.onscroll = async () => {
        //         let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

        //         if (bottomOfWindow && this.answers.length !== this.meta.total) {
        //             this.scrollLoading = true
        //             await this.getAnswers(this.id, this.meta.current_page + 1)
        //             this.scrollLoading = false
        //         }
        //     };
        // }
    }
    // updated() {
    //     this.scroll()
    // },
};
</script>

<style>
.nch--html-editor {
    width: 100%;
}
</style>
